import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { PrintOnlyImageSource } from 'pro-gallery';
function canReplace(src, base, target) {
  return src.indexOf(base) > 0 && src.indexOf(target) > -1 ? true : false;
}
function replaceWebp(src, target) {
  return src.replace('webp', target);
}
function originalSource(src) {
  if (canReplace(src, '.webp', '.png')) {
    return /*#__PURE__*/React.createElement("source", {
      srcSet: replaceWebp(src, 'png'),
      type: "image/png"
    });
  }
  if (canReplace(src, '.webp', '.jpg') || canReplace(src, '.webp', '.jpeg')) {
    return /*#__PURE__*/React.createElement("source", {
      srcSet: replaceWebp(src, 'jpeg'),
      type: "image/jpeg"
    });
  }
  return null;
}
function webpSource(src) {
  if (src.match(/\.\w{3,4}\/v\d\/\w*\//)) {
    // only change resized urls
    return /*#__PURE__*/React.createElement("source", {
      srcSet: src.replace(/(jpg|jpeg|png)$/, 'webp'),
      type: "image/webp"
    });
  }
  return null;
}
export class CustomImageRenderer extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "myRef", /*#__PURE__*/React.createRef());
  }
  render() {
    const props = this.props;
    if (typeof props.src === 'string') {
      const src = props.src;
      const imageProps = getImageProps(src, props);
      return /*#__PURE__*/React.createElement("picture", {
        key: `picture_${props.id}`
      }, webpSource(props.src), originalSource(props.src), /*#__PURE__*/React.createElement("img", imageProps));
    } else if (typeof props.src === 'object') {
      const src = props.src[props.src.length - 1].url;
      const imageProps = getImageProps(src, props);
      if (props.priorityLoading === true) {
        imageProps.loading = 'eager';
        imageProps.fetchpriority = 'high';
      } else if (props.priorityLoading === false) {
        imageProps.loading = 'lazy';
      } else {
        // leave the imageProps to the core logic.
      }
      return /*#__PURE__*/React.createElement("picture", {
        key: `multi_picture_${props.id}`
      }, props.src.map(currentSrc => {
        const type = `image/${currentSrc.type}`;
        const srcSet = currentSrc.dpr || currentSrc.url;
        const Source = currentSrc.forPrinting ? PrintOnlyImageSource : 'source';
        return /*#__PURE__*/React.createElement(Source, {
          srcSet: srcSet,
          type: type,
          key: `${props.id}-${currentSrc.forPrinting ? 'printingSrc-' : ''}${currentSrc.type}`
        });
      }), /*#__PURE__*/React.createElement("img", _extends({
        ref: this.myRef
      }, imageProps)));
    }
    return null;
  }
}
function getImageProps(src, props) {
  const imageProps = {
    src,
    alt: props.alt,
    className: props.className,
    style: props.style,
    'data-hook': props['data-hook'],
    loading: props.loading,
    onLoad: props.onLoad
  };
  return {
    ...imageProps
  };
}
//# sourceMappingURL=imageSourceRender.js.map